import moment from 'moment';
import { AuditLogRow } from '../../types/AuditLogs';

const csvHeaders = [
    'Timestamp (UTC)',
    'Actor (User Email)',
    'Target (Client / Property)',
    'Action Category',
    'Action / Change Detail'
];

const escapeCsvValue = (value?: string | number | boolean | null) => `"${`${value ?? ''}`.replace(/"/g, '""')}"`;

export const buildAuditLogCsv = (rows: AuditLogRow[]) => {
    const body = rows.map(row => {
        const actionAndChangeDetail = [row.operation, row.actionDetail].filter(Boolean).join(' — ');

        return [
            moment.utc(row.timestamp).format('YYYY-MM-DD HH:mm:ss [UTC]'),
            row.actor,
            row.target,
            row.actionCategory,
            actionAndChangeDetail
        ]
            .map(value => escapeCsvValue(value))
            .join(',');
    });

    return [csvHeaders.map(escapeCsvValue).join(','), ...body].join('\n');
};
